import React from 'react';
import { styled } from '@linaria/react';
import { File as FileIcon } from 'lucide-react';

import Expander from './Expander';
import { FileInterface } from './FileViewer.types';

interface Props {
  file: FileInterface;
  slug: string;
  isExpanded: boolean;
  onClick: (slug: string) => void;
}

function File({ file, slug, isExpanded, onClick }: Props) {
  return (
    <Wrapper
      style={{
        '--color': file.isSelected
          ? 'hsl(50deg 100% 60%)'
          : 'inherit',
      }}
      onClick={() => onClick(slug)}
      tabIndex={isExpanded === false ? -1 : undefined}
    >
      <Expander
        style={{
          '--opacity': file.isSelected ? 0.1 : 0,
        }}
      />
      <IconWrapper>
        <FileIcon
          size={14}
          color={
            file.isSelected
              ? 'hsl(50deg 100% 60%)'
              : 'hsl(0deg 0% 100% / 0.5)'
          }
        />
      </IconWrapper>
      <NameWrapper>{file.name}</NameWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  height: var(--row-height);
  color: var(--color);
  max-width: 100%;
`;

const IconWrapper = styled.div`
  transform: translateX(-2px);
`;

const NameWrapper = styled.div`
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export default File;
